import { ENTREPRISE_FORMATION_CONTEXT, ENTREPRISE_NAME, ALTERNANCE_MOBILITE } from "./lists";
import { SOURCE_EF } from "./constants";

export const formConfig = {
  title: {
    display: true,
    label: 'Ma super formation',
  },
  phone: '+33 1 76 41 13 15',
  introPage: false,
  multiPage: true,
  entryStep: 1,
  trainingsUrl: '',
  sourceOriginLead: SOURCE_EF,//SOURCE_IPAC empty or SOURCE_EF
  efArray: {
    token: 'f89f6901fb00093d129873fb3b9a55f2849a88b3',
    useTrainingArrayId: true,
    trainingIdFieldName: 'idFormationBitrix',
    mockPathName: 'inscription-anglais',
    domainId: 0,
  },
  gtm: {
    domain: 'https://www.googletagmanager.com/',
    scriptName: 'gtm.js',
    dataLayerName: 'dataLayer',
    id: 'GTM-57FTS53',
  },
  targetApi: '', // "https://europe-west1-ecole-francaise.cloudfunctions.net/formLead-preprod",
  redirect: {
    // onSuccess:
    //   "https://dev-cours.lecolefrancaise.fr/moncompteformation-faire-ma-demande/?first_parameter=mandatory",
    // onError: "https://dev-cours.lecolefrancaise.fr/erreur/",
    // onTimeout:
    //   "https://dev-cours.lecolefrancaise.fr/merci-pour-votre-inscription/",
  },
  legalMention: {
    display: true,
    label: "Conditions d'utilisation",
    link: 'https://lecolefrancaise.fr/cgv/',
  },
  avis: [
    {
      name: "Emmanuelle",
      title: "Un accompagnement de qualité !",
      description: "Le programme est très intéressant et complet ! L'accompagnement est de qualité, avec les différentes possibilités en fin de parcours pour se perfectionner. Formation très agréable qui ouvre des perspectives.",
    },
    {
      name: "Emilie B.",
      title: "Une formation qui s’adapte à mon quotidien",
      description: "Monter en compétences ou se reconvertir peut faire peur, mais quand la formation s’adapte à notre quotidien, que la plateforme est facile et intuitive, et que l’équipe pédagogique est derrière nous, c’est rassurant ! En tant que maman, j’avais besoin de trouver une formation qui puisse s’adapter à mon quotidien, tout en gardant mon poste. [...] Aussi, pouvoir utiliser la plateforme et le contenu pédagogique d’où l’on veut et quand on veut !",
    },
    {
      name: "Elliot M.",
      title: "Un rythme idéal pour se former chez soi",
      description: "Je me suis inscrit à L'École Française pour une formation en LSF, prise en charge avec mon CPF. Du très bon contenu, et merci à Selva de m'avoir suivi sur la formation, de m'avoir donné des objectifs précis qui m'ont aidé à trouver mon rythme.",
    },
    {
      name: "Aurélie H.",
      title: "Jamais seul dans cette aventure !",
      description: "Durant notre formation, nous ne sommes jamais tout seuls, l’équipe pédagogique est disponible et à l’écoute ! Amandine, ma responsable pédagogique, a su trouver les mots pour m’accompagner et me soutenir tout au long de mon parcours ! La motivation vient aussi de ceux avec qui on partage cette aventure : on s’encourage et se motive mutuellement !",
    },
    {
      name: "Remi L.",
      title: "Un tremplin vers l’entrepreneuriat",
      description: "Côté personnel, je ressens de la fierté d'avoir relevé un défi comme celui-ci et, bien sûr, d'avoir obtenu mon diplôme. Côté professionnel, mon objectif initial était de certifier mes compétences afin d'intégrer une plus grande structure et de gérer une équipe plus importante. Cette formation m'a fait grandir et m'a aidé à franchir le cap de l'entrepreneuriat.",
    },
    {
      name: "Karin l.",
      title: "Une véritable fierté de se former !",
      description: "La reprise de mes études était d'abord un challenge personnel : pouvoir me prouver que je pouvais réussir, tout en travaillant. Je voulais que mes proches et mes pairs soient fiers de moi, et aussi clouer le bec à certains qui me disaient que c'était impossible, que je n'y arriverais jamais. Ma motivation à moi, c'était ma fierté !",
    }
  ],
  form: [
    {
      index: 3,
      title: 'Dans quel domaine souhaitez-vous vous former ?',
      icon: '',
      key: 'domain',
      fields: [
        {
          name: 'domainId',
          type: 'domainsIcon',
          options: 'domains',
          default: '',
          label: 'Thématiques',
          required: true,
        },
      ],
    },
    {
      index: 4,
      title: 'Quelle formation vous intéresse ?',
      subtext: '',
      icon: '',
      key: 'training',
      fields: [
        {
          name: 'idFormationBitrix',
          type: 'detailedRadioIcon',
          options: 'trainingsByDomain',
          dataSet: 'trainings',
          default: '',
          label: 'Thématiques',
          required: true,
        },
      ],
    },
    {
      index: 2,
      title: 'Quel est votre principal objectif ?',
      subtext: 'Nous avons à cœur de connaître votre projet pour vous guider au mieux !',
      icon: '',
      key: 'objectif',
      fields: [
        {
          name: 'objectif',
          type: 'radioIcon',
          options: 'objectif',
          default: '',
          label: 'Objectifs',
          required: true,
        },
      ],
    },
    {
      index: 6,
      title: 'Comment comptez-vous financer votre formation ?',
      subtext:
        'Nos conseillers en formation vous orientent vers les meilleures solutions de financement.',
      icon: '',
      key: 'financement',
      fields: [
        {
          name: 'financement',
          type: 'radioIconConditioned',
          options: 'financement',
          condition: 'alternance',
          default: '',
          label: 'Financement',
          required: true,
        },
      ],
    },
    {
      index: 7,
      title: `Dans quel cadre s'effectue votre demande de formation  ?`,
      subtext:
        `Dans quel cadre s'effectue votre demande de formation `,
      icon: '',
      key: ENTREPRISE_FORMATION_CONTEXT,
      fields: [
        {
          name: ENTREPRISE_FORMATION_CONTEXT,
          type: 'radioIcon',
          options: 'formationContext',
          condition: '',
          default: '',
          label: 'FormationContext',
          required: true,
        },
      ],

    },
    {
      index: 8,
      title: `Veuillez indiquer le nom de votre entreprise `,
      subtext:
        `Veuillez indiquer le nom de votre entreprise `,
      icon: '',
      key: ENTREPRISE_NAME,
      fields: [
        {
          name: ENTREPRISE_NAME,
          type: 'flexInput',
          components: [
            {
              name: ENTREPRISE_NAME,
              type: 'input',
              pattern: 'name',
              placeholder: 'Entreprise',
              label: 'Entreprise',
              sublabel: '',
              required: true,
            },
          ],

        },
      ],
    },
    {
      index: 1,
      title: 'Quelle est votre situation professionnelle ?',
      subtext: '',
      icon: '',
      key: 'situationPro',
      fields: [
        {
          name: 'situationPro',
          type: 'radioIcon',
          options: 'situationPro',
          default: '',
          label: 'Situation professionnelle',
          required: true,
        },
      ],
    },
    {
      index: 5,
      title: "Quel est/sera votre niveau d'études au moment de débuter votre formation ?",
      subtext: 'Renseignez votre diplôme le plus élevé',
      icon: '',
      key: 'niveauEtudes',
      fields: [
        {
          name: 'etudes',
          type: 'radioIcon',
          options: 'niveauEtudes',
          default: '',
          label: "Niveau d'études",
          required: true,
        },
      ],
    },
    {
      index: 11,
      title: 'À quel email souhaitez-vous recevoir votre documentation ?',
      subtext:
        'Nous souhaitons vous accompagner le mieux possible dans votre projet, notre documentation vous sera transmise par mail.',
      icon: '',
      key: 'mailConsent',
      fields: [
        {
          name: 'email',
          type: 'email',
          pattern: 'email',
          placeholder: 'my@example.com',
          label: 'ADRESSE EMAIL',
          sublabel: '',
          required: true,
        },
        {
          name: 'consentPartners',
          type: 'consentCheckbox',
          required: false,
        },
      ],
    },
    {
      index: 12,
      title: 'Dernière étape avant de recevoir votre documentation :',
      subtext:
        'Remplissez vos coordonnées pour pouvoir être recontacté(e) et accompagné(e) dans votre projet',
      key: 'personalConsent',
      fields: [
        {
          name: 'gender',
          type: 'radio',
          options: 'gender',
          required: true,
        },
        {
          type: 'flexInput',
          name: 'nom_prenom',
          components: [
            {
              name: 'prenom',
              type: 'input',
              pattern: 'name',
              placeholder: 'Prénom',
              label: 'PRÉNOM',
              sublabel: '',
              required: true,
            },
            {
              name: 'nom',
              type: 'input',
              pattern: 'name',
              placeholder: 'Nom',
              label: 'NOM',
              sublabel: '',
              required: true,
            },
          ],
        },
        {
          name: 'numInt',
          type: 'tel',
          pattern: 'tel',
          label: 'TÉLÉPHONE',
          required: true,
        },
        {
          name: 'consentContact',
          type: 'consentCheckbox',
          required: true,
        },
      ],
    },
    {
      index: 9,
      title: 'Quelle est votre date de naissance ?',
      subtext: "Nous souhaitons identifier si vous-êtes éligible à l'alternance.",
      key: 'dateOfBirth',
      fields: [
        {
          name: 'dateOfBirth',
          type: 'date',
          pattern: 'date',
          label: 'DATE DE NAISSANCE',
          min: '1900-01-01',
          max: new Date().toISOString().split('T')[0],
          required: true,
        },
      ],
    },
    {
      index: 10,
      title: 'Dans quel département souhaitez vous effectuer votre alternance ?',
      subtext: "Nous souhaitons vous accompagner au mieux dans votre recherche d'entreprise en fonction de votre localisation.",
      key: ALTERNANCE_MOBILITE,
      fields: [
        {
          name: ALTERNANCE_MOBILITE,
          type: 'select',
          label: 'VOTRE DEPARTEMENT',
          placeholder: 'Choisissez votre département',
          required: true,
          options: 'departements',
          labelCallback: (option) => !!option && `${option.id} - ${option.label}`
        },
      ],
    },
  ],
  chargeBee: {
    site: 'lecolefrancaise',
    publishableKey: 'live_jyLt7NorFcFSBnNEjecucQwEu6ANP4rxs',
  },
};
